/**
 * Wrap an error with a prefix message, and preserve the original error message and stack trace.
 *
 * @example console.error(wrapError('Failed to upload file to s3 presigned url', e));
 * @param prefix - The message to prefix the original error message with
 * @param e - The original error to wrap
 * @returns
 */
const wrapError = (prefix: string, error: unknown): Error => {
  const message = error instanceof Error ? error.message : String(error);
  return new Error(`${prefix ? `${prefix}: ` : ''}${message}`);
};

/**
 * Create a new error with a message, and optionally wrap an existing error to preserve its message and stack trace.
 *
 * @example console.error(createError('Failed to upload file to s3 presigned url'));
 * @example console.error(createError('Failed to upload file to s3 presigned url', e));
 * @param message - The message to use for the new error
 * @param error - The original error to wrap (optional)
 * @returns
 */
export const createError = (message: string, error?: unknown): Error => {
  if (error) {
    return wrapError(message, error);
  }
  return new Error(message);
};
